var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('p',{staticClass:"title"},[_vm._v("이용약관")]),_c('div',[_c('p',{staticClass:"text0"},[_vm._v("AI튜터 Plus 이용약관")]),_c('p',{staticClass:"text1"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }